import { OrderRoutes } from '../orders-routes.enum';
import { nextRouteBasedOnOQ } from './common.flow';
import { FlowDefinition } from './flow.types';

export const VIDEO_FLOW: FlowDefinition = [
    {
        route: OrderRoutes.VIDEO_PACKAGE_SELECTION,
        next: (ctx, data) => data?.hasAtvProduct ? OrderRoutes.STREAM_HARDWARE_SELECTION
            : data?.hasDtvProduct ? OrderRoutes.SATELLITE_HARDWARE_SELECTION
            : null,
        back: ctx => ctx.isCommercial() ? OrderRoutes.WELCOME : OrderRoutes.BUNDLE_HOMEPAGE
    },
    {
        route: OrderRoutes.STREAM_HARDWARE_SELECTION,
        next: (ctx, data) => ctx.genrePackageSelected() ? OrderRoutes.STREAM_GENRE_PACK
            : ctx.isCommercial() ? OrderRoutes.ADDITIONAL_VIDEO_OFFERS
            : data?.creditCheckRequired ? OrderRoutes.CREDIT_CHECK
            : OrderRoutes.ADDITIONAL_VIDEO_OFFERS,
        back: OrderRoutes.VIDEO_PACKAGE_SELECTION
    },
    {
        route: OrderRoutes.SATELLITE_HARDWARE_SELECTION,
        next: ctx => ctx.isCommercial()
            ? OrderRoutes.ADDITIONAL_VIDEO_OFFERS
            : OrderRoutes.CREDIT_CHECK,
        back: OrderRoutes.VIDEO_PACKAGE_SELECTION
    },
    {
        route: OrderRoutes.DTV_VIDEO_COMMERCIAL_SATELLITE_OFFERS,
        next: ctx => ctx.isCommercial()
            ? OrderRoutes.ADDITIONAL_VIDEO_OFFERS
            : OrderRoutes.CREDIT_CHECK,
        back: OrderRoutes.VIDEO_PACKAGE_SELECTION
    },
    {
        route: OrderRoutes.STREAM_GENRE_PACK,
        next: OrderRoutes.ADDITIONAL_VIDEO_OFFERS,
        back: OrderRoutes.STREAM_HARDWARE_SELECTION
    },
    {
        route: OrderRoutes.CREDIT_RESULTS,
        next: ctx => !ctx.genrePackageSelected() ? OrderRoutes.ADDITIONAL_VIDEO_OFFERS
            : ctx.hasMyFreeResidentialStreamAccount() ? OrderRoutes.ALTERNATE_SHIPPING
            : OrderRoutes.EMAIL_VALIDATION,
        back: OrderRoutes.CREDIT_CHECK
    },
    {
        route: OrderRoutes.ADDITIONAL_VIDEO_OFFERS,
        next: OrderRoutes.ADDITIONAL_CHANNEL_OFFERS,
        back: ctx => ctx.genrePackageSelected() ? OrderRoutes.STREAM_GENRE_PACK
            : ctx.dtvStreamPackageSelected() ? OrderRoutes.STREAM_HARDWARE_SELECTION
            : ctx.dtvSatellitePackageSelected() ? OrderRoutes.SATELLITE_HARDWARE_SELECTION
            : null
    },
    {
        route: OrderRoutes.ADDITIONAL_CHANNEL_OFFERS,
        next: ctx => {
            if (ctx.genrePackageSelected()) {
                return ctx.closingOffersAvailable() ? OrderRoutes.CLOSING_OFFERS : OrderRoutes.CREDIT_CHECK;
            }
            if (ctx.dtvStreamPackageSelected()) {
                return ctx.closingOffersAvailable() ? OrderRoutes.CLOSING_OFFERS
                    : (ctx.isCommercial() || ctx.hasMyFreeResidentialStreamAccount()) ? OrderRoutes.ALTERNATE_SHIPPING
                    : OrderRoutes.EMAIL_VALIDATION;
            }
            if (ctx.dtvSatellitePackageSelected()) {
                return ctx.closingOffersAvailable() ? OrderRoutes.CLOSING_OFFERS
                    : ctx.isCommercial() ? OrderRoutes.ALTERNATE_SHIPPING
                    : OrderRoutes.PRODUCT_SUMMARY;
            }
            return null;
        },
        back: OrderRoutes.ADDITIONAL_VIDEO_OFFERS
    },
    {
        route: OrderRoutes.CLOSING_OFFERS,
        next: ctx => {
            if (ctx.genrePackageSelected()) {
                return OrderRoutes.CREDIT_CHECK;
            }
            if (ctx.dtvStreamPackageSelected()) {
                return (ctx.isCommercial() || ctx.hasMyFreeResidentialStreamAccount())
                    ? OrderRoutes.ALTERNATE_SHIPPING
                    : OrderRoutes.EMAIL_VALIDATION;
            }
            return ctx.dtvSatellitePackageSelected() ? OrderRoutes.PRODUCT_SUMMARY : null;
        },
        back: OrderRoutes.ADDITIONAL_CHANNEL_OFFERS
    },
    {
        route: OrderRoutes.EMAIL_VALIDATION,
        next: ctx => ctx.allowShippingAddressChange()
            ? OrderRoutes.ALTERNATE_SHIPPING
            : OrderRoutes.PRODUCT_SUMMARY,
        back: OrderRoutes.ADDITIONAL_CHANNEL_OFFERS
    },
    {
        route: OrderRoutes.ALTERNATE_SHIPPING,
        next: (ctx, data) => data?.oqResponse
            ? nextRouteBasedOnOQ(ctx, data.oqResponse, true)
            : OrderRoutes.PRODUCT_SUMMARY,
        back: (ctx, data) => {
            if (ctx.isResidentialSatelliteBillingAddressEnabled()) {
                return OrderRoutes.ORDER_OPTIONS;
            }
            if (ctx.isCommercial()) {
                return OrderRoutes.STREAM_HARDWARE_SELECTION;
            }
            if (ctx.hasMyFreeResidentialStreamAccount()) {
                return data?.hasClosingOffers ? OrderRoutes.CLOSING_OFFERS : OrderRoutes.ADDITIONAL_CHANNEL_OFFERS;
            }
            return OrderRoutes.EMAIL_VALIDATION;
        }
    },
    {
        route: OrderRoutes.CUSTOMER_ACCOUNT_SETUP,
        next: OrderRoutes.PRODUCT_SUMMARY,
        back: ctx => ctx.allowShippingAddressChange()
            ? OrderRoutes.ALTERNATE_SHIPPING
            : OrderRoutes.ADDITIONAL_VIDEO_OFFERS
    },
    {
        route: OrderRoutes.PRODUCT_SUMMARY,
        next: (ctx, data) => data?.oqResponse ? nextRouteBasedOnOQ(ctx, data.oqResponse) : OrderRoutes.ORDER_OPTIONS,
        back: (ctx, data) => {
            if (ctx.isResidential() && ctx.dtvSatellitePackageSelected()) {
                return data?.hasClosingOffers ? OrderRoutes.CLOSING_OFFERS : OrderRoutes.ADDITIONAL_CHANNEL_OFFERS;
            }
            if (ctx.allowShippingAddressChange() || (ctx.isCommercial() && ctx.dtvStreamPackageSelected())) {
                return OrderRoutes.ALTERNATE_SHIPPING;
            }
            if (ctx.dtvStreamPackageSelected()) {
                return OrderRoutes.STREAM_HARDWARE_SELECTION;
            }
            if (ctx.dtvSatellitePackageSelected()) {
                return OrderRoutes.SATELLITE_HARDWARE_SELECTION;
            }
            return OrderRoutes.VIDEO_PACKAGE_SELECTION;
        }
    }
];
